import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const RadioStarSelect = ({
  size = 16,
  title = 'Select',
  fill = colors.lemonade,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 35.142 33.576">
      {Boolean(title) && <title>{title}</title>}
      <g transform="translate(0.515 0.5)">
        <path
          d={`
M34.046,23.537a1.164,1.164,0,0,0-1.023-.807l-10.721-.9-4.17-9.915a1.18,
1.18,0,0,0-1.082-.728,1.151,1.151,0,0,0-1.082.728L11.8,21.825l-10.721.9a1.164,
1.164,0,0,0-1.023.807A1.212,1.212,0,0,0,.407,24.8l8.125,7.023L6.092,
42.284a1.177,1.177,0,0,0,1.751,1.279L17.05,38l9.207,5.567a1.153,1.153,0,0,
0,.61.177,1.239,1.239,0,0,0,.689-.216,1.144,1.144,0,0,0,.452-1.22L25.568,
31.838l8.125-7.023A1.182,1.182,0,0,0,34.046,23.537Z
`}
          transform="translate(-0.001 -11.183)"
          fill={fill}
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};
